import React from 'react';
import { useAdminTheme } from '../../../context/AdminThemeContext';

export default function AdminSidebarThemeToggle() {
  const { mode, toggleColorMode } = useAdminTheme();
  const isDark = mode === 'dark';

  return (
    <button
      type="button"
      className="admin-sidebar-theme-toggle"
      onClick={toggleColorMode}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark ? 'Light' : 'Dark'}
    </button>
  );
}
